/* Register the courtsideOS service worker.
 * Skipped in dev mode (npm start) since CRA HMR doesn't play well with SW caching;
 * runs in production builds and in the Emergent preview environment.
 */
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  // Skip on localhost dev unless explicitly forced.
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  if (isLocalhost && !window.location.search.includes("sw=1")) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Listen for waiting SW (new version available) — could surface a toast here later.
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // New SW ready — apply on next reload. Soft-prompt could be added in the future.
              // eslint-disable-next-line no-console
              console.info("[courtsideOS] update ready — reload to apply");
            }
          });
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[courtsideOS] service worker registration failed", err);
      });
  });
}
